const Savings = [
	{
		type: 'Livrets Bancaires',
		fields: [
			'bank_name'
		]
	},
	{
		type: 'Plan Epargne Logement (PEL)',
		fields: [
			'opening_date', 'ownership_type'
		]
	},
	{
		type: 'Comptes à terme',
		fields: [
			'ownership_type'
		]
	},
	{
		type: 'Autres liquidités',
		fields: [
			'ownership_type'
		]
	},
	{
		type: 'Assurances vie',
		fields: [
			'opening_date', 'ownership_type', 'investment_name', 'bank_name'
		]
	},
	{
		type: 'Plan Epargne en Action (PEA)',
		fields: [
			'opening_date', 'ownership_type', 'investment_name', 'bank_name'
		]
	},
	{
		type: 'Contrats de capitalisation',
		fields: [
			'opening_date', 'ownership_type', 'investment_name', 'bank_name'
		]
	},
	{
		type: 'PEP assurance vie',
		fields: [
			'opening_date', 'ownership_type', 'investment_name', 'bank_name'
		]
	},
	{
		type: 'PEP bancaires',
		fields: [
			'opening_date', 'ownership_type', 'investment_name', 'bank_name'
		]
	},
	{
		type: 'Comptes titres',
		fields: [
			'ownership_type', 'bank_name'
		]
	},
	{
		type: 'PEE',
		fields: [
			'opening_date', 'ownership_type'
		]
	},
	{
		type: 'PEA PME',
		fields: [
			'opening_date', 'ownership_type', 'bank_name'
		]
	},
	{
		type: 'FIP',
		fields: [
			'ownership_type'
		]
	},
	{
		type: 'FCPI',
		fields: [
			'ownership_type'
		]
	},
	{
		type: 'SOFICA',
		fields: [
			'ownership_type'
		]
	},
	{
		type: 'Contrats tontiniers',
		fields: [
			'ownership_type', 'ownership_type', 'investment_name', 'bank_name'
		]
	},
	{
		type: 'Autres titres non côtés',
		fields: [
			'ownership_type'
		]
	},
	{
		type: 'Autres valeurs mobilières',
		fields: [
			'ownership_type'
		]
	},
	{
		type: 'Autres Épargnes',
		fields: [
			'ownership_type'
		]
	}
]

export default Savings



// WEBPACK FOOTER //
// ./src/common/components/MyPatrimonialLandscape/data/Savings.js